import { DataUnit } from '@/core/types';
import { Badge } from '../Badge/Badge';
import TipIcon from '@/icons/tip.svg?react';
import Button from '../Button';
import { useTranslation } from 'react-i18next';
import Tooltip from '../Tooltip/Tooltip';
import { DataCorrectionStatusEnum } from '@/core/enums';

interface Props {
  unit: DataUnit | undefined;
  onConfirm: (() => void) | undefined;
  disabled: boolean;
  styling?: 'short' | 'long';
}

export const ConfrimDataUnit = ({
  unit,
  onConfirm,
  disabled,
  styling = 'long',
}: Props) => {
  const { t } = useTranslation();

  if (!unit) return null;

  return (
    <>
      {!!unit.confirmation_date &&
      unit.correction_status === DataCorrectionStatusEnum.Blocked ? (
        <Tooltip
          content={
            <>
              {unit.confirmed_by ? (
                <>
                  {' '}
                  <div className='text-center'>
                    {t(
                      'You have confirmed that all data is correct and complete'
                    )}
                  </div>
                  <div className='text-center'>
                    {t(
                      'The data is now locked and reports are being prepared or already completed'
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className='text-center'>
                    {t(
                      'The deadline has passed; your data is confirmed and locked'
                    )}
                  </div>
                  <div className='text-center'>
                    {t('Reports are being prepared or already completed')}
                  </div>
                </>
              )}
              <div className='text-center'>
                {t('Any corrections will incur additional charges')}
              </div>
            </>
          }
        >
          <Badge
            testId={`du-${unit.id}-confirmed-badge`}
            color='green'
            label={
              <div className='flex items-center gap-x-1'>
                <span>{t('Confirmed as ready')}</span>
                {!unit.confirmed_by && (
                  <span data-testid='automatically-confirmed-badge'>{`(${t(
                    'Automatically'
                  )})`}</span>
                )}
                <TipIcon className='AgendaModal__icon' />
              </div>
            }
          />
        </Tooltip>
      ) : styling === 'short' ? (
        <Button
          onClick={onConfirm}
          size='sm'
          data-testid={`du-${unit.id}-confirm-btn`}
          disabled={disabled}
        >
          {t('Confirm data readiness')}
        </Button>
      ) : (
        <div className='flex items-center gap-x-2 rounded-lg bg-gray-70 pl-2'>
          <span className='font-semibold'>{t('Confirm data readiness')}</span>
          <Button
            onClick={onConfirm}
            size='sm'
            data-testid={`du-${unit.id}-confirm-btn`}
            disabled={disabled}
          >
            {t('Confirm')}
          </Button>
        </div>
      )}
    </>
  );
};
